import Card from "components/card";
import React, {useMemo, useState} from "react";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import useAsyncEffect from "use-async-effect";
import FirmwareUploadHistory from "./FirmwareUploadHistory";
import FirmwareUploadFile from "./FirmwareUploadFile";

const FirmwareUpload = () => {

        const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
        const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

        //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
        //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
        const secretKey = "cromptonssecretkey";

        let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
        const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
        const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
        const navigate = useNavigate();
        const [loading, setLoading] = useState(true);
        const [pg, setpg] = useState(0);
        const [rpg, setrpg] = useState(5);
        let [total, setTotal] = useState(0)
        let [dpInfos, setDpInfos] = useState([])

        const handleLogOut = async () => {
            try {
                await logOut();
                navigate("/");
            } catch (error) {
                ////console.log(error.message);
            }
        }

        /*useAsyncEffect(async () => {
                //console.log(accesscontrollevel)
                if (accesscontrollevel.toString() === "1") {
                    // console.log("Inisde USEA")
                    //console.log((JSON.parse(sessionStorage.getItem("productInfoData"))).dpInfos)

                    //setDpInfos((JSON.parse(sessionStorage.getItem("productInfoData"))).dpInfos)
                    //console.log(dpInfos)
                }
                setLoading(false)

            }, []
        );*/

        return (
            <Card extra={'w-full h-full mt-3 p-4'}>
                <div className="mt-3 grid h-full grid-cols-1 gap-5 xl:grid-cols-1 2xl:grid-cols-2">
                    <div className="col-span-1 h-fit w-full xl:col-span-1 2xl:col-span-1">
                        <FirmwareUploadFile/>
                    </div>
                    <div className="col-span-1 h-full w-full rounded-xl 2xl:col-span-1">
                        <FirmwareUploadHistory/>
                    </div>
                </div>
            </Card>
        )
            ;
    }
;

export default FirmwareUpload;
